import { Component, OnInit, inject } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

@Component({
  selector: "app-floorplan-opacity-menu",
  imports: [UiKitModule, ReactiveFormsModule],
  templateUrl: "./floorplan-opacity-menu.component.html",
  styleUrl: "./floorplan-opacity-menu.component.scss",
})
export class FloorplanOpacityMenuComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private floorplanService = inject(FloorplanService);

  protected opacityForm!: FormGroup;
  protected showOpacityMenu: boolean = false;

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    const opacityValue: number = this.floorplanService.selectedFloorplan.floorplanState.opacity;
    this.opacityForm = this.formBuilder.group({
      opacity: [opacityValue],
    });
    this.opacityForm.valueChanges.subscribe((value) => {
      if (!this.opacityForm.valid || this.opacityForm.pristine) return;
      this.update(value.opacity);
    });
  }

  toggleOpacityMenu() {
    this.showOpacityMenu = !this.showOpacityMenu;
  }

  protected resetOpacity() {
    this.opacityForm.get("opacity")!.setValue(100);
  }

  private update(value: number) {
    this.floorplanService.selectedFloorplan.floorplanState.opacity = value;
  }
}
